var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--input_otp-input display-flex justify-content-center align-items-center gap-10"
  }, [_c('input', {
    staticClass: "display-none",
    attrs: {
      "autocomplete": "off",
      "name": "hidden",
      "type": "text"
    }
  }), _vm._v(" "), _vm._l(_vm.numInputs, function (item, i) {
    return _c('SingleOtpInput', {
      key: i,
      attrs: {
        "focus": _vm.activeInput === i,
        "value": _vm.otp[i],
        "separator": _vm.separator,
        "input-type": _vm.inputType,
        "input-classes": _vm.inputFinalClasses(i),
        "input-mode": _vm.inputMode,
        "is-last-child": i === _vm.numInputs - 1,
        "should-auto-focus": _vm.shouldAutoFocus
      },
      on: {
        "on-change": _vm.handleOnChange,
        "on-keydown": _vm.handleOnKeyDown,
        "on-paste": _vm.handleOnPaste,
        "on-focus": function ($event) {
          return _vm.handleOnFocus(i);
        },
        "on-blur": _vm.handleOnBlur
      }
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }